module.exports = __webpack_public_path__ + "img/user-menu-cards.9bfe200b.svg";